<script lang="ts">
import { formatTryTimeRemaining } from '$lib/api/try';
import { Link } from '$lib/components/link';

export let robotID: string;
export let robotName: string;
export let timeRemaining: number;
</script>

<div class="flex h-full w-full gap-2">
  <Link
    class="px-1 py-2 text-sm font-bold uppercase hover:bg-gray-8"
    href="/try"
  >
    Try viam
  </Link>
  <span
    class="flex h-full items-center bg-[#4E4F52] px-2"
    role="timer"
  >
    {formatTryTimeRemaining(timeRemaining)}
  </span>
  <span class="flex items-center px-1 py-2 hover:bg-gray-8">
    rover: <Link href={`/machine/${robotID}?isTrySession=true`}>
      {robotName}</Link
    >
  </span>
</div>
